export default {
    methods: {
        selectCurrency(currency) {
            const currentCurrency = this.$store.getters.selectedCurrency;

            // Re-selecting the currency that's already active is a no-op. Without this guard,
            // a redundant call would re-emit 'currency.changed' here, flipping every vehicle
            // card's currencyIsChanging flag back to true - but since setCurrencyState (correctly)
            // no-ops for a redundant currency, the vehicles list never gets re-committed, so
            // that flag never resets and the cards get stuck showing the "..." price placeholder.
            if (currency && currentCurrency && currency.code === currentCurrency.code) {
                return;
            }

            this.$store.dispatch('setCurrencyState', currency).catch((error) => {
                this.$store.dispatch('createError', error);
            }).then(() => {
                if (window.bus) {
                    window.bus.$emit('currency.changed', currency);
                }
            });
        },
    },
};
